import { makeAutoObservable } from 'mobx'
import { IProfileGetProfile } from '../interfaces/rpc/IProfileGetProfile'
import { IBusinessGetProfileById } from '../interfaces/rpc/IBusinessGetProfileById'

export class ProfileStore {
  public profile: IProfileGetProfile | null = null
  public business: IBusinessGetProfileById | null = null
  public businessId = ''

  constructor() { makeAutoObservable(this) }

  get isSuperUser() {
    return this.profile?.profile.access_control.find(i => i.business.role === 'superuser')
  }

  get currentUserEmail() {
    return this.profile?.profile.email[0] ?? ''
  }

  get currentUserEmails() {
    return this.profile?.profile.email || []
  }
}
